import { render } from "./RobotInfo.vue?vue&type=template&id=f7b8e246&scoped=true"
import script from "./RobotInfo.vue?vue&type=script&lang=js"
export * from "./RobotInfo.vue?vue&type=script&lang=js"

import "./RobotInfo.vue?vue&type=style&index=0&id=f7b8e246&lang=scss"
import "./RobotInfo.vue?vue&type=style&index=1&id=f7b8e246&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f7b8e246"

export default script